<script>
export default {
  name: 'Progress',
  components: {},
  props: {
    value: {
      type: Number,
      required: true,
    },
    textValue: {
      type: String,
      required: true,
    },
  },
  methods: {},
}
</script>

<template>
  <div
    class="content"
  >

    <b-progress
      class="progress"
    >
      <b-progress-bar
        :value="value"
      />
    </b-progress>
    <div class="text">
      <span>{{ textValue }}</span>
    </div>
  </div>
</template>


<style scoped lang="scss">
@import '@design';

.content {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 3rem;
  padding: 1rem;
  border-top: 1px solid $divider-gray;
}

.progress {
  width: 84%;
  height: 5px;
  border-radius: 30px !important;

  > div {
    background-image: $color-button-bg-gradient-rappi-orange;
    border-radius: 30px !important;
  }
}

.text {
  width: 9%;
  margin: 0 0.5em 0 0.5rem;
  font-size: 15px;
  color: $orange-primary;
}
</style>
